import { render, staticRenderFns } from "./AdvancedVue.vue?vue&type=template&id=0126809c&"
import script from "./AdvancedVue.vue?vue&type=script&lang=js&"
export * from "./AdvancedVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports